import { Idp } from "../idp";
import { log } from "../../utils";
export class PageBase {
    constructor(target, parent, user) {
        var _a, _b;
        this.target = target;
        this.parent = parent;
        this.user = user;
        this.documentId = 0;
        // distance from viewport origin
        this.absoluteLeft = 0;
        this.absoluteTop = 0;
        // eslint-disable-next-line no-use-before-define
        this.frames = [];
        this.queue = [];
        this.idp = new Idp();
        this.sheetIds = {};
        this.ecounter = 0;
        this.lastSync = Date.now();
        this.cleared = false;
        (_a = this.target) !== null && _a !== void 0 ? _a : (this.target = document.documentElement);
        if (this.target.tagName === "IFRAME") {
            this.defaultView = (_b = this.target.contentDocument) === null || _b === void 0 ? void 0 : _b.defaultView;
        }
        else {
            this.defaultView = this.target.ownerDocument.defaultView;
        }
        this.idp.set(this.getDocument(), 1);
    }
    setEvents(events) {
        if (events.input) {
            this.input.track(this.getDocument());
        }
        else if (events.input === false) {
            this.input.untrack();
        }
        if (events.cursor) {
            this.cursor.track(this.getDocument());
        }
        else if (events.cursor === false) {
            this.cursor.untrack();
        }
        if (events.scroll) {
            this.scroll.track();
        }
        else if (events.scroll === false) {
            this.scroll.untrack();
        }
        if (events.highlight) {
            this.highlighter.track();
        }
        else if (events.highlight === false) {
            this.highlighter.untrack();
        }
        this.forEachFrame((pg) => pg.setEvents(events));
    }
    getWindow() {
        return this.defaultView.window;
    }
    getDocument() {
        return this.defaultView.document;
    }
    forEachFrame(callback) {
        this.frames.forEach(callback);
    }
    handleRemoteInput(event) {
        this.input.dispatch(event.payload);
    }
    handleRemoteScroll(ev) {
        this.scroll.dispatch(ev.payload, ev.time);
    }
    handleRemoteCursor(ev) {
        this.cursor.dispatch(ev.payload);
    }
    get closed() {
        var _a;
        return this.cleared || ((_a = this.getWindow()) === null || _a === void 0 ? void 0 : _a.closed) !== false;
    }
    cleanup(shallow = false) {
        var _a;
        this.cleared = true;
        if (!shallow) {
            this.forEachFrame((pg) => pg.cleanup());
        }
        this.frames = [];
        try {
            (_a = this.location) === null || _a === void 0 ? void 0 : _a.untrack();
            this.scroll.untrack();
            this.highlighter.untrack();
            this.input.untrack();
            this.cursor.untrack();
        }
        catch (ex) {
            log("Cobrowser cleanup failed:", ex);
        }
        this.cleanIdp();
        this.queue = [];
    }
    /** clean everything related to an id */
    cleanIdp() {
        var _a;
        this.sheetIds = {};
        this.queue = ((_a = this.queue[0]) === null || _a === void 0 ? void 0 : _a.type) === "PageMetadata" ? [this.queue[0]] : [];
        this.idp.reset();
        this.idp.set(this.getDocument(), 1);
    }
    getPageByFrame(iframe) {
        return this.frames.find((page) => page.target === iframe);
    }
    untrackFrame(iframe) {
        const page = this.getPageByFrame(iframe);
        page === null || page === void 0 ? void 0 : page.cleanup();
        this.frames = this.frames.filter((pg) => pg !== page);
    }
    getTime() {
        return Date.now();
    }
    get isRoot() {
        return this.parent === null;
    }
    event(type, payload, document = this.documentId) {
        return {
            type,
            time: this.getTime(),
            document,
            endpoint: this.user.endpoint,
            payload,
        };
    }
}
PageBase.SyncRequestPeriod = 5000;
